import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { useBoolean } from "usehooks-ts";
import Icon from "../icon/index.js";
import Tooltip from "../../others/tooltip/index.js";
const defaultTooltipProps = {
    placement: 'bottom-start',
    isNegative: false
};
export const IconWithTooltip = ({ className , tooltipProps , children  })=>{
    const iconRef = useRef(null);
    const { value , setFalse , setTrue  } = useBoolean();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                "data-testid": "IconWithTooltip",
                className: className,
                ref: iconRef,
                onMouseEnter: setTrue,
                onMouseLeave: setFalse
            }),
            value && !!children && /*#__PURE__*/ _jsx(Tooltip, {
                referenceElement: iconRef.current,
                ...defaultTooltipProps,
                ...tooltipProps,
                children: children
            })
        ]
    });
};
export default IconWithTooltip;

//# sourceMappingURL=index.js.map